<template>
  <div class="name-intro-wrapper">
    <h1 class="name-intro-title">
      {{ config.title }}
    </h1>
    <div class="name-intro-desc">
      <p v-for="(item,index) in config.desc" :key="`name-intro-${index}`">
        {{ item }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    config: {
      default: () => {},
      type: Object,
    },
  },
  data() {
    return {
    }
  },
  methods: {
  },
}
</script>

<style lang="scss" scoped>
.name-intro-wrapper {
  position: relative;
  margin: 100px auto;
  padding: 120px 48px;
  width: 1240px;
  height: 510px;
  background-color: rgba(255, 170, 10, 0.05);
  border-radius: 16px;

  &::after {
    position: absolute;
    top: -40px;
    right: 85px;
    width: 400px;
    height: 594px;
    content: '';
    background-image: url('~assets/images/about-us/hk-name-intro.png');
    background-size: 400px 594px;
    background-repeat: no-repeat;
  }

  .name-intro-title {
    margin-bottom: 40px;
    font-size: 48px;
    font-weight: 600;
    color: var(--txt-color-lv1);
    line-height: 56px;
  }

  .name-intro-desc {
    >p {
      margin-bottom: 20px;
      width: 627px;
      font-size: 20px;
      font-weight: 500;
      color: var(--txt-color-lv3);
      line-height: 28px;
    }

    & :last-child {
      margin-bottom: 0;
    }
  }
}
</style>
